import { create } from 'zustand';
import { authService } from '../services/auth.service';
import { toast } from 'sonner';

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;
const SINDICATO_PASSWORD = process.env.REACT_APP_SINDICATO_PASSWORD;

export const useAuthStore = create((set) => ({
    isAdminMode: false,
    isSindicatoMode: false,
    isLoggingIn: false,
    isAuthenticated: false,

    login: async (cpf) => {
        set({ isLoggingIn: true });
        try {
            if (cpf === ADMIN_PASSWORD) {
                set({ isAdminMode: true, isSindicatoMode: false, isAuthenticated: true, isLoggingIn: false });
                return { success: true, role: 'admin' };
            }

            if (cpf === SINDICATO_PASSWORD) {
                set({ isSindicatoMode: true, isAdminMode: false, isAuthenticated: true, isLoggingIn: false });
                return { success: true, role: 'sindicato' };
            }

            const data = await authService.login(cpf);
            set({ isAdminMode: false, isSindicatoMode: false, isAuthenticated: true, isLoggingIn: false });
            return { success: true, role: 'user', data, cpf };
        } catch (e) {
            set({ isLoggingIn: false });
            toast.error(e.message || "Falha ao conectar à API. Tente novamente mais tarde.");
            return { success: false, error: e.message };
        }
    },

    logout: () => {
        set({ isAdminMode: false, isSindicatoMode: false, isAuthenticated: false });
    },
}));
